import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faAngleDown,
  faAngleRight,
  faArchive,
  faCalculator,
  faCalendarAlt,
  faClipboardList,
  faCog,
  faCopy,
  faDownload,
  faExclamationCircle,
  faFile,
  faFileAlt,
  faFolder,
  faFolderOpen,
  faGlobe,
  faInfoCircle,
  faLockAlt,
  faPen,
  faPlusCircle,
  faPrint,
  faSearch,
  faShoppingCart,
  faTrashAlt,
  faTimes,
} from '@fortawesome/fontawesome-pro-regular';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.node,
  ]),
  tooltipText: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.node,
    PropTypes.string,
  ]),
  iconName: PropTypes.string,
  hasIconHover: PropTypes.bool,
  isFontAwesome: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onClick: PropTypes.func,
  iconColor: PropTypes.string,
  direction: PropTypes.string,
  tooltipStyle: PropTypes.shape({
    top: PropTypes.string,
    right: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    whiteSpace: PropTypes.string,
  }),
};

const defaultProps = {
  hasIconHover: true,
  isFontAwesome: '',
  iconName: '',
  iconColor: '#777',
};

class TooltipIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      fontIcons: [
        faAngleDown,
        faAngleRight,
        faArchive,
        faCalculator,
        faCalendarAlt,
        faClipboardList,
        faCog,
        faCopy,
        faDownload,
        faExclamationCircle,
        faFile,
        faFileAlt,
        faFolder,
        faFolderOpen,
        faGlobe,
        faInfoCircle,
        faLockAlt,
        faPen,
        faPlusCircle,
        faPrint,
        faSearch,
        faShoppingCart,
        faTrashAlt,
        faTimes,
      ],
    };
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    this.setState({ hover: true });
  }

  handleMouseLeave() {
    this.setState({ hover: false });
  }

  render() {
    const {
      className,
      onClick,
      iconName,
      tooltipText,
      hasIconHover,
      isFontAwesome,
      iconColor,
      direction,
      tooltipStyle,
    } = this.props;
    const { hover, fontIcons } = this.state;
    return (
      <Tooltip
        className={className}
        tooltip={tooltipText}
        style={tooltipStyle}
        direction={direction}
      >
        <div
          className="iconLayer"
          style={{
            width: 25,
            height: 25,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {isFontAwesome ? (
            <FontAwesomeIcon
              className="fontIcon"
              icon={fontIcons.find((fontItem) => {
                return fontItem.iconName === iconName;
              })}
              style={{
                fontSize: '18px',
                opacity: 1,
                outLine: 'none',
                background: 'transparent',
                color: hasIconHover && hover ? '#26abe3' : iconColor,
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.65, 0.05, 0.36, 1)',
                transitionProperty: 'all',
                transitionDuration: '0.3s',
                transitionTimingFunction: 'cubic-bezier(0.65, 0.05, 0.36, 1)',
                transitionDelay: '0s',
              }}
              onClick={onClick}
              onMouseEnter={hasIconHover && this.handleMouseEnter}
              onMouseLeave={hasIconHover && this.handleMouseLeave}
            />
          ) : (
            <i
              className={iconName}
              style={{
                fontSize: '18px',
                opacity: 1,
                background: 'transparent',
                color: hasIconHover && hover ? '#26abe3' : iconColor,
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.65, 0.05, 0.36, 1)',
                transitionProperty: 'all',
                transitionDuration: '0.3s',
                transitionTimingFunction: 'cubic-bezier(0.65, 0.05, 0.36, 1)',
                transitionDelay: '0s',
              }}
              onClick={onClick}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
            />
          )}
        </div>
      </Tooltip>
    );
  }
}

TooltipIcon.propTypes = propTypes;
TooltipIcon.defaultProps = defaultProps;

export default TooltipIcon;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/TooltipIcon/index.js
 **/